export interface Features {
  failingRequestRetriesOnSubmit: number;
  personlizationEnabled: boolean;
  /*                      */
  christmasDate: Date;
}

export function initFeatureFlags(features: Features) {
  features.failingRequestRetriesOnSubmit = 20;
  features.personlizationEnabled = true;
  /*                      */
  features.christmasDate = new Date("12/26/2023");
}
